/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import _get from 'lodash/get';
import _round from 'lodash/round';
import _min from 'lodash/min';
var DEFAULT_CONFIG = {
    CLOUD_PLAYER_URL: '',
    RTE_VIEWER_URL: '',
    CLOUD_PLAYER_ENABLED: true,
    RTE_VIEWER_ENABLED: true,
    CDN_ASSET_PREFIX: 'lib',
};
var Player = /** @class */ (function () {
    function Player(asset, config) {
        var _this = this;
        this.getDisplacement = function (tiling) {
            var physicalSize = _get(_this.asset, 'extraData.physicalSize', null);
            if (!physicalSize)
                return 0;
            physicalSize = physicalSize
                .split('/')
                .map(function (i) { return parseFloat(i) / 100; });
            if (!physicalSize[2] ||
                _this.asset.getExtraData('previewStyleSketchfab') === 'cloth')
                return 0;
            return _round((2 * physicalSize[2]) /
                (_min([physicalSize[0], physicalSize[1]]) * tiling), 6);
        };
        this.canDisplayCloudPlayer = function () {
            return _this.isEnabled && _this.isSupported;
        };
        this.asset = asset;
        this.config = __assign(__assign({}, DEFAULT_CONFIG), config) || DEFAULT_CONFIG;
        this.url = this.getPlayerUrl();
    }
    Player.prototype.getTiling = function () {
        var tilingFactor;
        var assetTiling = _get(this.asset, 'extraData.previewTiling', 1);
        var previewStyleSketchfab = _get(this.asset, 'extraData.previewStyleSketchfab', null);
        var specificTiling = _get(this.asset, 'specificTiling');
        if (specificTiling) {
            return specificTiling();
        }
        switch (previewStyleSketchfab) {
            case 'sub_sphere':
                tilingFactor = 3;
                break;
            case 'plane':
                tilingFactor = 2;
                break;
            case 'cloth':
                tilingFactor = 3;
                break;
            default:
                tilingFactor = 2;
        }
        return assetTiling * tilingFactor;
    };
    Player.prototype.getWebGlContext = function (type) {
        if (type === void 0) { type = 'webgl'; }
        if (!document) {
            return;
        }
        var canvas = document.createElement('canvas');
        return canvas.getContext(type);
    };
    Player.prototype.isWebGlSupported = function () {
        var webglContext = this.getWebGlContext();
        return !!webglContext;
    };
    Player.prototype.isWebGl2Supported = function () {
        return !!this.getWebGlContext('webgl2');
    };
    return Player;
}());
export default Player;
